import React from 'react';
import { NODE_DEFS } from './BlueprintNode';
import { cn } from '@/OS/lib/utils';

export default function NodePalette({ onDragStart }: { onDragStart: (event: React.DragEvent, type: string) => void }) {

  return (
    <div className="h-full w-full flex flex-col">
      <div
        className={cn(
          'rounded-xl shadow-md border bg-gradient-to-br from-background/80 to-muted/60 dark:from-background/90 dark:to-muted/40 p-4 m-3 flex flex-col gap-3'
        )}
        style={{ minHeight: 'calc(100vh - 80px - 24px)', backdropFilter: 'blur(2px)' }}
      >
        <div className="font-semibold text-sm mb-2 text-foreground/80">Nodes</div>
        {NODE_DEFS.filter(n => n.type !== 'start' && n.type !== 'end').map(node => (
          <div
            key={node.type}
            className={cn(
              'flex items-center gap-3 px-3 py-2 rounded-lg group transition-all cursor-grab border border-transparent hover:border-accent',
              'bg-background/80 dark:bg-background/60 shadow-sm'
            )}
            draggable
            onDragStart={event => onDragStart(event, node.type)}
            style={{ borderLeft: `8px solid ${node.accentColor}`, boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)' }}
          >
            <div className={cn('rounded-full p-2 shadow', node.accent, 'bg-gradient-to-br', node.color)}>{node.icon}</div>
            <div>
              <div className="font-bold text-sm text-foreground">{node.title}</div>
              <div className="text-xs text-muted-foreground">{node.subtitle}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}